<template>
  <div class="GatedContentOption">
    <h3 class="heading">{{ content.heading }}</h3>
    <p class="subheading">{{ content.subheading }}</p>
    <SanityImage v-if="content.image" :asset="content.image.asset" class="image"/>
    <div v-if="content.body" class="body">
      <PortableText :blocks="content.body" />
    </div>
    <DownloadForm class="form" :requestedContent="content.requestedContent" v-bind="{ whenSubmitted }" />
  </div>
</template>

<script>
import DownloadForm from './form/DownloadForm.vue'

export default {
  components: {
    DownloadForm,
  },
  props: {
    content: Object,
    whenSubmitted: Function,
  },
}
</script>

<style scoped>

.GatedContentOption {
  color: var(--text-color-black);
}

.heading {
  font-weight: 600;
  font-size: var(--font-size-3);
}

.subheading {
  margin-top: var(--spacing-0);
  font-weight: 500;
  font-size: var(--font-size-2);
}

.image {
  margin-top: var(--spacing-4);
  max-height: 8rem;
}

.body {
  margin-top: 0.25rem;
  font-weight: 400;
  font-size: var(--font-size-2);
  line-height: 1.5;
}

.body:deep(ul) {
  margin-top: var(--spacing-4);
  font-weight: 500;
}

.body:deep(ul li) {
  background-image: var(--bullet-image, url('../../../../../assets/bullets/bullet-light.svg'));
  background-position: 0 4px;
  background-repeat: no-repeat;
  padding-left: 28px;
}

.body:deep(p) {
  margin-top: var(--spacing-4);
}

.form {
  margin-top: var(--spacing-6);
}
</style>
